/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

class akoLinePopup extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", function () {
      function getCookieValue(name) {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim();
          if (cookie.startsWith(name + "=")) {
            return cookie.substring(name.length + 1);
          }
        }
        return "";
      }

      var lineWrapper = document.querySelector(".line-wrapper");
      var lineCloseCookie = getCookieValue("lineClose");
      let lineIntro = document.querySelector(".line-intro");

      if (lineCloseCookie === "true") {
        lineWrapper.remove();
      }

      var closeLineButton = document.querySelector(".line-info-close");
      if (closeLineButton) {
        closeLineButton.addEventListener("click", function () {
          var expirationDate = new Date();
          expirationDate.setTime(
            expirationDate.getTime() + 15 * 60 * 60 * 1000
          );
          document.cookie =
            "lineClose=true; expires=" +
            expirationDate.toUTCString() +
            "; path=/";
          lineWrapper.remove();
        });
      }
    });
  }
}
customElements.define("line-popup", akoLinePopup);

class mainEventForm extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", function () {
      function assembleAndSetValues(callback) {
        var participantDivs = document.querySelectorAll('[id^="_input"]');
        var numDivs = participantDivs.length;
        var completedCount = 0;

        participantDivs.forEach(function (participantDiv, index) {
          var values = getInputValues(participantDiv);
          setValuesToHiddenInput(values, index);

          completedCount++;

          if (completedCount === numDivs) {
            callback();
          }
        });
      }

      var form = document.querySelector(".needs-validation");
      var inputs = form.querySelectorAll("input[required]");
      var selects = form.querySelectorAll("select[required]");
      var radios = form.querySelectorAll('input[type="radio"][required]');

      function validateAndToggleValidity(input) {
        if (input.type === "radio") {
          var radioGroup = form.querySelectorAll(
            'input[name="' + input.name + '"]'
          );
          var isChecked = Array.from(radioGroup).some(function (radio) {
            return radio.checked;
          });

          if (!isChecked) {
            radioGroup.forEach(function (radio) {
              radio.classList.add("is-invalid");
            });
          } else {
            radioGroup.forEach(function (radio) {
              radio.classList.remove("is-invalid");
            });
          }
        } else if (input.value.trim() === "") {
          input.classList.add("is-invalid");
        } else {
          input.classList.remove("is-invalid");
        }
      }

      document.addEventListener("keydown", function (event) {
        if (event.key === " ") {
          event.preventDefault();
        }
      });
      function validateFormAndSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        if (event.key === " ") {
          event.preventDefault();
        }

        var isValid = true;

        selects.forEach(function (select) {
          validateAndToggleValidity(select);
          if (select.classList.contains("is-invalid")) {
            isValid = false;
          }
        });

        inputs.forEach(function (input) {
          validateAndToggleValidity(input);
          if (input.classList.contains("is-invalid")) {
            isValid = false;
          }
        });

        radios.forEach(function (radio) {
          validateAndToggleValidity(radio);
          if (radio.classList.contains("is-invalid")) {
            isValid = false;
          }
        });

        if (isValid) {
          assembleAndSetValues(function () {
            var addToCartButton = document.querySelector(
              ".event-addtocart #AddToCart"
            );
            if (addToCartButton) {
              addToCartButton.click();
            }
          });
        }
      }
      var checkRequiredButton = document.getElementById("CheckRequired");
      if (checkRequiredButton) {
        checkRequiredButton.addEventListener("click", validateFormAndSubmit);
      }
      selects.forEach(function (select) {
        select.addEventListener("change", function () {
          event.stopPropagation();
          validateAndToggleValidity(select);
        });
      });

      inputs.forEach(function (input) {
        input.addEventListener("input", function () {
          event.stopPropagation();
          validateAndToggleValidity(input);
        });
      });

      radios.forEach(function (radio) {
        radio.addEventListener("input", function () {
          event.stopPropagation();
          validateAndToggleValidity(radio);
        });
      });

      var numericInputs = document.querySelectorAll('input[name^="純數字"]');

      numericInputs.forEach(function (input) {
        input.addEventListener("input", function (event) {
          var inputValue = event.target.value;
          var numericValue = inputValue.replace(/[^\d]/g, "");

          var errorMessage = document.getElementById(
            "error_message_" + input.getAttribute("id")
          );

          if (inputValue !== numericValue) {
            if (errorMessage) {
              errorMessage.style.display = "block";
            }
          } else {
            if (errorMessage) {
              errorMessage.style.display = "none";
            }
          }

          input.value = numericValue;
        });
      });

      var SyncButtons = document.querySelectorAll('[id^="sync_"]');

      SyncButtons.forEach(function(syncCheckbox) {
        syncCheckbox.addEventListener("change", function() {
          var dataSetValue = syncCheckbox.dataset.set;
          var input1 = document.getElementById(dataSetValue);
          var targetID = syncCheckbox.getAttribute("name").replace("sync_", "")
          var inputTarget = document.getElementById(targetID);
          
     
            if (syncCheckbox.checked) {
              if (input1.value.trim() !== "") {
                inputTarget.value = input1.value;
                inputTarget.setAttribute("readonly", "true");
              } else {
                alert("請先填寫主報名人資料");
                syncCheckbox.checked = false;
              }
            }
              else {
                inputTarget.removeAttribute("readonly");
              }
        });
      });

      function setValuesToHiddenInput(values, index) {
        var hiddenInput = document.getElementById("參加者_" + (index + 1));
        if (hiddenInput) {
          hiddenInput.value = values;
          console.log(values);
        }
      }

      function getInputValues(inputDiv) {
        var values = [];

        var inputs = inputDiv.querySelectorAll(
          'input[type="text"]:not([hidden]):not([name^="純數字"]), input[type="radio"]:checked, select:not([name^="日期"])'
        );
        inputs.forEach(function (input) {
          var inputValue = input.value.trim();
          values.push(inputValue !== "" ? inputValue : "無");
        });

        const datePicker = inputDiv.querySelectorAll('select[name^="日期"]');
        if (datePicker.length > 0) {
          var year = inputDiv.querySelector('select[name^="日期年"]');
          var month = inputDiv.querySelector('select[name^="日期月"]');
          var day = inputDiv.querySelector('select[name^="日期日"]');

          var birthDate =
            "'" + year.value + "/" + month.value + "/" + day.value;
          if (year.value !== "" && month.value !== "" && day.value !== "") {
            values.push(birthDate);
          } else {
            birthDate = "無";
            values.push(birthDate);
          }
        }

        const numPicker = inputDiv.querySelectorAll('input[name^="純數字"]');
        if (numPicker.length > 0) {
          var numInput = inputDiv
            .querySelector('input[name^="純數字"]')
            .value.trim();
          numInput = numInput !== "" ? "'" + numInput : "無";
          values.push(numInput);
        }

        return values.join("|");
      }
    });
  }
}
customElements.define("main-event-form", mainEventForm);

class akoLuckyCard extends HTMLElement {
  constructor() {
    super();
    function applyFlipCardOnMobile() {
      const screenWidth = window.innerWidth;
      const card = document.querySelector(".flip-card");
      const flipCardInner = document.querySelector(".flip-card-inner");

      if (screenWidth <= 768) {
        card.addEventListener("click", function () {
          flipCardInner.style.transform =
            flipCardInner.style.transform === "rotateY(180deg)"
              ? "rotateY(0)"
              : "rotateY(180deg)";
        });
      } else {
        card.addEventListener("mouseenter", function () {
          flipCardInner.style.transform = "rotateY(180deg)";
        });

        card.addEventListener("mouseleave", function () {
          flipCardInner.style.transform = "rotateY(0)";
        });
      }
    }

    function luckyCard() {
      const query = `
        query{
             product(id: "gid://shopify/Product/${lucky_card[randomNumber]}") {
              id
              title
              description
              images(first: 2) {
                edges {
                  node {
                    originalSrc
                  }
                }
              }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    priceV2 {
                      amount
                      currencyCode
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
              complementary_products: metafield(namespace:  "shopify--discovery--product_recommendation", key: "complementary_products") {
                  value
            }
            }
          }
        
        `;

      fetch("https://linlinkaiyun.myshopify.com/api/2023-04/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "bc18ea8bf89f2f672bc293b0723cfc37",
        },
        body: JSON.stringify({
          query,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          var title = data.data.product.title.replace("好命卡：", "");
          let frontImage = document.querySelector(".flip-card-image.front");
          let backImage = document.querySelector(".flip-card-image.back");
          let frontImageURL =
            data.data.product.images.edges[0].node.originalSrc;
          frontImage.src = frontImageURL;
          const frontNewSrcset = `${frontImageURL}?width=600 600w, ${frontImageURL}?width=700 700w, ${frontImageURL}?width=800 800w, ${frontImageURL}?width=1000 1000w`;
          frontImage.setAttribute("srcset", frontNewSrcset);
          let backImageURL = data.data.product.images.edges[1].node.originalSrc;
          backImage.src = backImageURL;
          const backNewSrcset = `${backImageURL}?width=600 600w, ${backImageURL}?width=700 700w, ${backImageURL}?width=800 800w, ${backImageURL}?width=1000 1000w`;
          backImage.setAttribute("srcset", backNewSrcset);

          backImage.src = data.data.product.images.edges[1].node.originalSrc;
          console.log(frontImageURL);
          document.querySelector(".luckyCard_title").innerHTML = title;
        });
    }

    applyFlipCardOnMobile();
    luckyCard();
  }
}
customElements.define("lucky-card", akoLuckyCard);
